(function ( $ ) {

    $(document).on('ready', function () {

        if ( document.body.classList.contains('wp-admin') ) {
            // when in admin-editor - looping hero-thumb aligning as it can not be 100% fully predicted when Property Spaces block preview will be rendered in admin editor
            // (and also - if block was loaded in edit mode - this code will be looping till user will not turn block to preview mode)
            var intervalCounter = 0;
            var interval = setInterval(function () {
                var $spaceCards = $('.space-cards');
                if ( $spaceCards.length > 0 || intervalCounter++ > 5 ) { // to stop interval if no $spaceCards were found after 5 iterations (after 5*2000ms = 10 sec)
                    alignSpaceCardsDescriptionsHeight($spaceCards);
                    clearInterval(interval); // stopping loop for hero-thumb aligning
                }
            }, 2000);
        }
        else {
            var isMobile = $('#is-mobile').filter(':visible').length > 0;
            if ( !isMobile ) {
                alignSpaceCardsDescriptionsHeight($('.space-cards'));
            }
        }
    });

    function alignSpaceCardsDescriptionsHeight($spaceCards){
        // according to designs - all .space-card__description elements should have same height, to do this - we align them with js by getting
        // height of the highest .space-card__description of current .space-cards grid and changing height for all cards' height in it to maxCardDescrHeight value
        if ( $spaceCards.length > 0 ) {
            var $cardsDescr = $spaceCards.find('.space-card__description');
            var maxCardDescrHeight = 0;
            $cardsDescr.each(function () {
                var thisDescrHeight = $(this).height();
                if ( thisDescrHeight > maxCardDescrHeight ) maxCardDescrHeight = thisDescrHeight;
            });

            if ( maxCardDescrHeight > 0 ) $cardsDescr.height(maxCardDescrHeight).addClass('visible');
        }
    }

})( jQuery )